export default "__VITE_ASSET__COsKkKoW__"